// import { useEffect, useState } from 'react';
// import { useSearchParams } from 'react-router-dom';
// import { Box, Flex, Text } from '@chakra-ui/react';
// const LeaderboardFriendsFilter = () => {
//   const [searchParams, setSearchParams] = useSearchParams();
//   const filterButtons = [
//     {
//       name: 'all',
//       value: false,
//     },
//     {
//       name: 'friends',
//       value: true,
//     },
//   ];
//   return (
//     <Flex w="100%" flexDirection="row" justifyContent="space-between" pl="54px" gap="10px">
//       <Flex flex="1" justifyContent="flex-start">
//         <Text textAlign="left" variant="pageTitle">
//           leaderboard
//         </Text>
//       </Flex>
//       <Flex flex="1" justifyContent="flex-end" alignItems="center" gap="8px">
//         {filterButtons.map((button) => (
//           <Flex
//             key={button.name}
//             background={searchParams.get('friends') === `${button.value}` ? '#fff' : 'rgba(255,255,255,0.06)'}
//             p="4px 10px"
//             borderRadius="10px"
//             transition="all 0.2s ease"
//             onClick={() => {
//               setSearchParams((sp) => {
//                 const newParams = new URLSearchParams(sp);
//                 newParams.set('friends', `${button.value}`);
//                 return newParams;
//               });
//             }}
//           >
//             <Text
//               fontSize="16px"
//               fontWeight="700"
//               lineHeight="1"
//               transition="all 0.2s ease"
//               color={
//                 searchParams.get('friends') === `${button.value}` ? 'rgba(36, 36, 36, 1)' : 'rgba(255,255,255,0.8)'
//               }
//             >
//               {button.name}
//             </Text>
//           </Flex>
//         ))}
//       </Flex>
//     </Flex>
//   );
// };
// export default LeaderboardFriendsFilter;
import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';

import { Box, Fade, Flex, Grid, Text, keyframes } from '@chakra-ui/react';
import routes from 'routes';

import BurgerButton from 'components/BurgerButton';
import Menu from 'components/layout/Menu';

import { useAppSelector } from 'hooks/app';

import { ReactComponent as LeftArrowIcon } from 'icons/back-arr.svg';
import { ReactComponent as LogoIcon } from 'icons/logo.svg';

const topLineAnimation = keyframes`
  0% {
    transform: translateY(0);
    top: 0;
  }
  50% {
    top: 50%;
    transform: translateY(-50%);
  }
  100% {
    top: 50%;
    transform: translateY(-50%) rotate(45deg);
  }
`;

const topLineAnimationReverse = keyframes`
  0% {
    
     top: 50%;
    transform: translateY(-50%) rotate(-45deg);
  }
  50% {
    top: 50%;
    transform: translateY(-50%);
  }
  100% {
   transform: translateY(0);
    top: 0;
  }
`;

const bottomLineAnimation = keyframes`
  0% {
    transform: translateY(0);
    bottom: 0;
  }
  50% {
    bottom: 50%;
    transform: translateY(50%);
  }
  100% {
    bottom: 50%;
    transform: translateY(50%) rotate(-45deg);
  }
`;

const bottomLineAnimationReverse = keyframes`
  0% {
    bottom: 50%;
    transform: translateY(50%) rotate(45deg);
  }
  50% {
    bottom: 50%;
    transform: translateY(50%);
  }
  100% {
    transform: translateY(0);
    bottom: 0;
  }
`;

const LeaderboardFriendsFilter = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [gotNewMessage, setGotNewMessage] = useState(false);
  const user = useAppSelector((store) => store.auth.user);

  useEffect(() => {
    if (!searchParams.has('friends')) {
      setSearchParams((sp) => {
        const newParams = new URLSearchParams(sp);
        newParams.set('friends', `false`);
        return newParams;
      });
    }
  }, [searchParams, setSearchParams]);

  useEffect(() => {
    if (!(window as any).fcSettings) return;
    (window as any).fcSettings = {
      onInit: function () {
        (window as any).fcWidget.on('unreadCount:notify', function (resp: { count: number }) {
          setGotNewMessage(resp.count > 0);
        });
      },
    };
  }, [user]);

  const filterButtons = [
    {
      name: 'all',
      value: false,
    },
    {
      name: 'friends',
      value: true,
    },
  ];

  return (
    <Flex w="100%" flexDirection="row" justifyContent="space-between" px="12px" gap="10px">
      <Grid gridTemplateColumns="48px 1fr 48px" alignItems="center" gap="10px" w="100%">
        {/* <Box as={Link} to={routes.home}>
          <LeftArrowIcon />
        </Box> */}
        <BurgerButton
          isMenuOpen={isMenuOpen}
          toggleMenu={() => setIsMenuOpen(!isMenuOpen)}
          hasNotification={gotNewMessage}
        />
        <Flex flex="1" justifyContent="center">
          <Text textAlign="center" variant="pageTitle" fontSize="16pxpx" lineHeight="1.3">
            Leaderboard
          </Text>
        </Flex>
        <Flex />
      </Grid>

      {/* <Flex flex="1" justifyContent="flex-end" alignItems="center" gap="8px">
        {filterButtons.map((button) => (
          <Flex
            key={button.name}
            background={searchParams.get('friends') === `${button.value}` ? '#fff' : 'rgba(255,255,255,0.06)'}
            p="4px 10px"
            borderRadius="10px"
            transition="all 0.2s ease"
            cursor="pointer"
            _active={{ backgroundColor: 'rgba(255,255,255,0.1)' }}
            onClick={() => {
              setSearchParams((sp) => {
                const newParams = new URLSearchParams(sp);
                newParams.set('friends', `${button.value}`);
                return newParams;
              });
            }}
          >
            <Text
              fontSize="16px"
              fontWeight="700"
              lineHeight="1"
              transition="all 0.2s ease"
              color={
                searchParams.get('friends') === `${button.value}` ? 'rgba(36, 36, 36, 1)' : 'rgba(255,255,255,0.8)'
              }
            >
              {button.name}
            </Text>
          </Flex>
        ))}
      </Flex> */}
      <Fade
        in={isMenuOpen}
        style={{
          zIndex: 99,
          position: 'absolute',
          top: '0',
          left: '0',
          right: '0',
          bottom: '0',
          background: '#242424',
        }}
        unmountOnExit
      >
        <Menu onClose={() => setIsMenuOpen(false)} user={user} />
      </Fade>
    </Flex>
  );
};

export default LeaderboardFriendsFilter;
